import request from "@/utils/oms-request";

export const searchProductCategories = (params: any) =>
  request({
    url: "/product-categories",
    method: "get",
    params
  });

export const deleteProductCategory = (id: any) =>
  request({
    url: `/product-categories/${id}`,
    method: "delete"
  });

export const disabledProductCategory = (id: any) =>
  request({
    url: `/product-categories/${id}/update-disabled`,
    method: "put"
  });

// 上传产品
export const uploadProduct = (data: FormData) =>
  request({
    headers: { "Content-Type": "multipart/form-data" },
    url: "/products/upload-product",
    method: "post",
    data
  });
// 上传产品绩效目标
export const uploadProductPerformanceTarget = (data: FormData) =>
  request({
    headers: { "Content-Type": "multipart/form-data" },
    url: "/products/upload-performance-target",
    method: "post",
    data
  });

export const searchProducts = (params: any) =>
  request({
    url: "/products",
    method: "get",
    params
  });

export const deleteProduct = (id: any) =>
  request({
    url: `/products/${id}`,
    method: "delete"
  });

export const disabledProduct = (id: any) =>
  request({
    url: `/products/${id}`,
    method: "put"
  });

export const uploadDynamicsExcel = (replace, data: FormData) =>
  request({
    headers: { "Content-Type": "multipart/form-data" },
    url: `/products/dynamics-excel?replace=${replace}`,
    method: "post",
    data: data
  });

export const getInquirySheetTableHeader = () =>
  request({
    url: `/inquiry-sheet/table-header`,
    method: "GET"
  });
// 维护询价单
export const updateInquirySheetTableHeader = (accountTypeByOperation:string) =>
  request({
    url: `/inquiry-sheet/table-header/update`,
    method: "GET",
    params:{
      accountTypeByOperation:accountTypeByOperation
    }
  });
export const getQuoteLibraryTableHeader = () =>
  request({
    url: `/quote-library/table-header`,
    method: "GET"
  });

export const saveRFQ = (data: any) =>
  request({
    url: `/products/RFQ`,
    method: "POST",
    data
  });
export const queryTaskInfo = (id: any) =>
  request({
    url: `/task/${id}/info`,
    method: "GET",
  });
// 根据产品名称模糊查询
export const listProductName = (params: any) =>
    request({
        url: `/products/names`,
        method: "get",
        params
    });
